import { createContext, useContext } from "react";

// Shared auth context for the admin console. Kept in its own module so pages
// can consume it without importing AdminRoot (avoids circular imports).
export const AdminAuthContext = createContext({ user: null, logout: async () => {} });

export const useAdminAuth = () => useContext(AdminAuthContext);
